import { type StackProps, useTheme } from '@mui/material';
import Stack from '@mui/material/Stack';
import { Button } from '../../components/button/index.ts';
import { ClearIcon } from '../../assets/icons/clear.tsx';
import { buttonSx, getClearButtonSx, getKeyButtonSx, getWrapperSx } from './styles.ts';


type PT = StackProps & { onClearButtonClick: () => void, onKeyClick: (value: string) => void, disabled?: boolean };

const keys = new Array(9).fill(0).map((_, i) => String(++i));
export const Keyboard = (props: PT) => {
  const { sx, onClearButtonClick, onKeyClick, disabled, ...rest } = props;
  const theme = useTheme();
  return (
    <Stack
      sx={getWrapperSx(sx)}
      {...rest}>
      {keys.map((key, i) => (
        <Button
          disabled={disabled}
          onClick={() => onKeyClick(key)}
          key={i}
          variantStyle="secondary"
          sx={getKeyButtonSx(theme)}
        >
          {key}
        </Button>
      ))}
      <Button
        disabled={disabled}
        variantStyle={'secondary'}
        sx={getClearButtonSx(theme)}
        onClick={onClearButtonClick}>
        <ClearIcon />
      </Button>

      <Button
        disabled={disabled}
        onClick={() => onKeyClick('0')}
        variantStyle="secondary"
        sx={buttonSx}
      >
        {0}
      </Button>
    </Stack>
  );
};
